
import React, { useEffect, useState } from 'react';
import useAxios from 'hooks/useAxios';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    CardHeader,
    Button,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import Drawer from 'components/Drawer';
import ErrorBoundary from 'components/ErrorBoundary';
import CustomeDate from 'pages/ClientDashBoard/Components/Widgets/CustomeDate';
import CostPerRxDrawer from '../GridData/CostPerRxDrawer';

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend
);
const plugin = {
    beforeInit(chart) {
        // Get reference to the original fit function
        const originalFit = chart.legend.fit;

        // Override the fit function
        chart.legend.fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)();
            // Change the height as suggested in another answers
            this.height = this.height + 25;
        };
    },
};

const CostPerRx = ({ dateRange, planId, groupId, startDate, endDate, rebatechecked, costPerrx }) => {
    const API = useAxios();
    const [active, setActive] = useState('3');
    const [graphData, setGraphData] = useState(null);
    const [options, setOptions] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [disabledViewButtom, setDisabledViewButtom] = useState(true);
    useEffect(() => {

        setActive(dateRange);
        getCostPerRx();
    }
        , [costPerrx]);

    const [chartData, setChartData] = useState({
        labels: [], // This will hold months
        datasets: [], // This will hold product data
    });


    const getCostPerRx = async () => {
        let options = {
            responsive: true,
            scales: {
                x: {
                    stacked: true,
                },
                y: {
                    stacked: false,
                    ticks: {
                // include a dollar sign in the ticks
                callback: function (value, index, values) {
                    if (value >= 1000) {
                        return (
                            '$' + (value / 1000) + 'k'
                        );
                    }
                    else {
                        return (
                            '$' + value
                        );
                    }

                }
            },
                },
            },
            
            plugins: {
                legend: {
                        position: 'bottom',
                    labels: {
                        padding: 15,
                        usePointStyle: true,
                        pointStyle: 'rect',
                        color: '#707070',
                        font: {
                            weight: 'bold',
                        },
                    },
                    align: 'start',
                },
                tooltip: {
                    enabled: true,
                    position: 'nearest',
                    mode: 'index',
                    intersect: false,
                    callbacks: {

                        label: function (d, t) {
                            var xLabel = d.dataset.label;
                            var yLabel = '$' + d.formattedValue;
                            return xLabel + ': ' + yLabel;
                        },
                    },
                },
                datalabels: {
                    display: false,
                    align: function (context) {
                        return context.dataset.data[context.dataIndex] < 150000
                            ? 'end'
                            : 'start';
                    },
                    color: function (context) {
                        return context.dataset.data[context.dataIndex] < 150000
                            ? 'black'
                            : 'black';
                    },
                    anchor: 'end',
                    padding: {
                        right: 2,
                    },
                    labels: {
                        padding: { top: 10 },
                        value: {
                            color: '#2B3346',
                        },
                    },
                    formatter: function (value) {
                        return (
                            '$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                        );
                    },
                },
            }
        };
        setOptions(options)
        let grpData = {
            labels: costPerrx?.label,

            datasets: [
                {
                    label: "Plan Pay Spend Per Rx",
                    data: costPerrx?.planPaySpend,
                    borderColor: "#702C62",
                    backgroundColor: "#702C62",
                    pointRadius: 2.5
                },
                {
                    label: "Patient Pay Spend Per Rx",
                    data: costPerrx?.patientPaySpend,
                    borderColor: '#B54DA0',
                    backgroundColor: '#B54DA0',
                    pointRadius: 2.5
                },
                
                {
                    label: "Total Spend Per Rx",
                    data:  costPerrx?.totalPaySpend,
                    borderColor: '#e0dbdbff',
                    backgroundColor: '#e0dbdbff',
                    pointRadius: 2.5
                },

            ],
        };
        setGraphData(grpData);
          if (costPerrx?.planPaySpend!=null ||costPerrx?.patientPaySpend!=null ||costPerrx?.totalPaySpend!=null) {
                setDisabledViewButtom(false);
            }
            else {
                setDisabledViewButtom(true);
            }
    }
    const handleActive = (title) => {
        setActive(title);
    };
    const getDate = () => {
        setActive('custom')
    }
    const handleProceed = () => {
        setIsOpen(!isOpen);
    }
    const onHandleIsOpen = (hasRefresh) => {
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
    }

    //   return <Bar options={options} data={chartData} />;
    return (
        <ErrorBoundary>
            <Card className='p-3 h-100'>
                <CardHeader className='border-0 bg-white px-0 pt-0'>
                    <Row className='align-items-center'>
                        <Col>
                            <CardTitle className='f-20 font-weight-500'>
                                Cost Per Rx
                                <span className='qu_icon' style={{ "paddingLeft": "10px" }} data-title={"The total Plan Paid amount for the net processed, non-reversed claims per month."}>
                                    {/* <img src={QuestionIcon} style={{"width":"20px"}} /> */}
                                </span>
                            </CardTitle>
                        </Col>
                        <Col xs='auto' hidden={true}>
                            <Nav className='widget-tabs'>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '3'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'cursor-pointer f-12'
                                        }
                                        onClick={() => handleActive('3')}
                                    >
                                        3 Mon
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '6'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'f-12 cursor-pointer'
                                        }
                                        onClick={() => handleActive('6')}
                                    >
                                        6 Mon
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '12'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'cursor-pointer f-12'
                                        }
                                        onClick={() => handleActive('12')}
                                    >
                                        1 Yr
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={
                                        active === 'custom'
                                            ? 'active-tab cursor-pointer f-12'
                                            : 'cursor-pointer f-12'
                                    }>
                                        <CustomeDate getDate={getDate} active={active} />
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody className='dashboard-chart-body'>
                    {graphData && (<Bar options={options} data={graphData} plugins={[plugin]} />)}
                    <div className="view-report">
                        <Button
                            color='primary'
                            className='ms-2'
                            onClick={handleProceed}
                           // style={{ float: "right", marginTop: "26px" }}
                            style={{ float: "right", position: "absolute", bottom: "3px", right: "30px"}}
 
                            disabled={disabledViewButtom}
                        >
                            View Report
                        </Button>
                    </div>
                </CardBody>
            </Card>
              <Drawer
            direction='end'
            title='Cost Per Rx'
            isOpen={isOpen}
            toggle={handleProceed}
            size="lg"
        >
            <CostPerRxDrawer dateRange={dateRange} planId={planId} groupId={groupId} startDate={startDate} endDate={endDate} onHandleIsOpen={onHandleIsOpen} rebatechecked={rebatechecked} />
        </Drawer> 
        </ErrorBoundary>
    )
};

export default CostPerRx;

